/**
 * Patterns of errors to suppress from RUM reporting.
 * These are expected/benign errors that would pollute dashboards.
 */
const IGNORE_PATTERNS: RegExp[] = [
  // Amplify auth lifecycle (expected during OAuth flow)
  /No current user/,
  /User is not authenticated/,
  // WebSocket disconnects (expected on page nav / sleep)
  /WebSocket is not open/,
  /WebSocket connection closed/,
  // Browser resize observer (benign, browser quirk)
  /ResizeObserver loop/,
  // Network errors during prefetch (user navigates away mid-request)
  /Failed to fetch/,
  /AbortError/,
  /The operation was aborted/,
];

/**
 * RUM error handler — returns true if the error should be IGNORED.
 */
export function shouldIgnoreError(
  event: ErrorEvent | PromiseRejectionEvent,
): boolean {
  const message =
    event instanceof ErrorEvent
      ? event.message || event.error?.message || ""
      : (event.reason?.message ?? String(event.reason ?? ""));

  return IGNORE_PATTERNS.some((pattern) => pattern.test(message));
}
